// WHY a module-level singleton (not React state): Zustand store actions and the
// apiClient request interceptor need to read preview-mode synchronously from outside
// the React render tree. Threading a React context through every store action and
// interceptor would invert the dependency graph (services importing React). The
// trade-off is intentional — PreviewDataProvider owns the lifecycle (mount = on,
// unmount = off) so the flag's mutation surface stays tiny.
let active = false;

export function setPreviewMode(value: boolean): void {
  active = value;
}

export function isPreviewMode(): boolean {
  return active;
}
